export default "using System;\n\nclass Program\n{\nstatic void Main()\n{\nui().s2p().mm().supplinvoice().manage().util().Constants().blabla();\n}\n}\n"